import styled from '@emotion/styled';
import { TabletWidth } from '../../../global.style';

const absoluteHeaderTopMargin = 20
const absoluteHeaderLogoHeight = 24
export const absoluteHeaderHeight = absoluteHeaderTopMargin + absoluteHeaderLogoHeight


export const AbsoluteHeaderWrapper = styled.div`
  margin-bottom: ${absoluteHeaderTopMargin}px;
`;

export const AbsoluteHeaderBackArrowImg = styled.img`
  cursor: pointer;
  position: absolute;
  left: 92px;
  top: 134px;

  @media (max-width: ${TabletWidth}px) {
    left: 24px;
    top: 25px;
  }
`;

export const AbsoluteHeaderLogoWrapper = styled.div`
  position: absolute;
  height: ${absoluteHeaderLogoHeight}px;
  top: 25px;
  width: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const AbsoluteHeaderLogo = styled.img`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    position: absolute;
    height: auto;
    display: inline-block;
    width: 70px;
    left: 50%;
    top: 25px;
    transform: translate(-50%, -50%);
  }
`;
